import { useEffect, useState } from 'react';
import { hasRetro } from 'lib/helpers';
import useFetch from 'lib/hooks/useFetch';

import { selectCurrentUser } from 'features/auth/slice';
import { useSelector } from 'react-redux';

import {
  recordsMatch,
  Tabs,
  useModal,
} from '@frontendmentorio/design-system-v2';

import CodeEditor from './CodeEditor';
import Description from './Description';
import DesignComparison from './DesignComparison';
import Discord from 'features/shared/Discord';
import Feedback from './Feedback';
import Hero from './Hero';
import Reports from './Reports';
import AccessibilityModal from './Reports/AccessibilityModal';
import CSSModal from './Reports/CSSModal';
import HTMLModal from './Reports/HTMLModal';
import JSModal from './Reports/JSModal';

export default function Show({ data }) {
  const currentUser = useSelector(selectCurrentUser);

  const accessibilityModal = useModal();
  const cssModal = useModal();
  const htmlModal = useModal();
  const jsModal = useModal();

  const {
    data: { data: solution },
  } = useFetch(`/api/v3/solutions/${data.id}`, {
    fallbackData: { data },
  });

  const isAuthor = recordsMatch(currentUser, solution?.user);
  const isReportVisible = isAuthor || currentUser?.admin;

  const [activeTab, setActiveTab] = useState(
    isReportVisible ? 'design' : 'code'
  );

  useEffect(() => {
    if (isReportVisible) setActiveTab('design');
  }, [isReportVisible]);

  return (
    <>
      <Hero solution={solution} />

      <div className="pb-6 pt-8 px-5">
        <div className="container-xl flex flex-col gap-8">
          {hasRetro(solution) && <Description solution={solution} />}

          {isReportVisible && <Reports solution={solution} />}

          <div className="flex flex-col gap-4 items-start">
            <Tabs
              activeTab={activeTab}
              ariaLabel={
                isAuthor
                  ? 'Select code browser, design comparison or solution reports'
                  : 'Select code browser or design comparison'
              }
              dropdownClassName="w-full z-20 mobile:block mobile:w-1/2 tablet:hidden"
              onChange={setActiveTab}
              options={[
                { label: 'Code', value: 'code' },
                { label: 'Design comparison', value: 'design' },
              ]}
              tabsClassName="mobile:hidden tablet:inline-flex"
            />

            {activeTab === 'code' && (
              <CodeEditor isAuthor={isAuthor} solution={solution} />
            )}

            {activeTab === 'design' && (
              <DesignComparison
                challenge={solution.challenge}
                solution={solution}
              />
            )}
          </div>

          <Feedback solution={solution} />
          <Discord />
        </div>
      </div>

      <AccessibilityModal modal={accessibilityModal} />
      <CSSModal modal={cssModal} />
      <HTMLModal modal={htmlModal} />
      <JSModal modal={jsModal} />
    </>
  );
}
